import Avo from 'analytics/Avo';
import { ViewPricingIconInstaShop } from 'assets/icons';
import Button from 'components/atoms/Button';
import { BUTTON_NAMES } from 'constant/button-names';
import { useConfig } from 'context/app-config';
import PricingSheet from 'packages/shared/pricing/PricingSheet';
// import { pages } from 'pages';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

interface RightArrowIconProps extends React.SVGProps<SVGSVGElement> {
  arrowColor?: string;
}

const StyledPriceListButton = styled(Button)`
  background-color: ${({ theme }) => theme.components.pages.home?.viewPricingButton?.bgColor};
  border-color: ${({ theme }) => theme.components.pages.home?.viewPricingButton?.borderColor};
  color: ${({ theme }) => theme.components.pages.home?.viewPricingButton?.textColor};
  border-width: 1px;
  margin-right: 10px;
  width: ${({ theme }) => theme.components.pages.home?.viewPricingButton?.width ?? '60%'};
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  &:hover,
  &:focus,
  &:active,
  &.btn-primary:not(:disabled):not(.disabled):active {
    background-color: ${({ theme }) => theme.components.pages.home?.viewPricingButton?.bgColor};
    border-color: ${({ theme }) => theme.components.pages.home?.viewPricingButton?.borderColor};
    color: ${({ theme }) => theme.components.pages.home?.viewPricingButton?.textColor};
  }
  @media (max-width: 444px) {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    font-size: 0.9rem;
  }
  @media (max-width: 359px) {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    font-size: 0.79rem;
  }
  @media (max-width: 330px) {
    padding-left: 0.15rem;
    padding-right: 0.15rem;
    font-size: 0.77rem;
  }
  @media (max-width: 290px) {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding: 0rem;
    height: 40px;
    width: 70%;
    font-size: 0.69rem;
  }
  @media (max-width: 270px) {
    height: 40px;
    padding-left: 0.15rem;
    padding-right: 0.15rem;
    font-size: 0.59rem;
  }
`;

const StyledViewPricingIcon = styled(ViewPricingIconInstaShop)<RightArrowIconProps>`
  margin-right: 8px;
  @media (max-width: 360px) {
    margin-right: 4px;
  }
  @media (max-width: 430px) {
    margin-right: 4px;
  }
`;

const PricingButton: React.FC = () => {
  const { t } = useTranslation();
  const [showPricingSheet, setShowPricingSheet] = React.useState(false);
  const togglePricingSheet = React.useCallback((value: boolean) => setShowPricingSheet(value), []);
  const config = useConfig();
  const handleClosePricingSheet = useCallback(() => {
    togglePricingSheet(false);
  }, [togglePricingSheet]);

  const theme = useTheme();

  const onClickPricing = useCallback(() => {
    togglePricingSheet(true);
    Avo.viewPricing({ screen: 'Home Page Footer' });
  }, [togglePricingSheet]);

  const PricingSheetComponent = useMemo(
    () => <PricingSheet show={showPricingSheet} onClose={handleClosePricingSheet} />,
    [showPricingSheet, handleClosePricingSheet]
  );

  return (
    <>
      <StyledPriceListButton
        buttonName={BUTTON_NAMES.VIEW_PRICING}
        onClick={onClickPricing}
        className="d-flex justify-content-center align-items-center py-2 mt-2 margin-end-3"
      >
        {!theme.components.pages.home?.placeOrderFooter?.hideIcon && !config?.hidePricingButtonIcon && (
          <StyledViewPricingIcon arrowColor={theme.components.pages.home?.placeOrderFooter?.arrowColor} />
        )}
        {t('homePage.viewPricing')}
      </StyledPriceListButton>
      {PricingSheetComponent}
    </>
  );
};

export default PricingButton;
